var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/button-has-type */
import classnames from 'classnames';
import React, { useMemo, useCallback } from 'react';
import { createPrefixCls } from '../_utils/string';
import { Loading } from '../loading';
const prefixCls = createPrefixCls('btn');
export const Button = React.forwardRef((_a, ref) => {
    var { children, type = 'primary', size = 'normal', className, htmlType = 'button', shape = 'circle', shadow, plain, loading, disabled, onClick } = _a, restProps = __rest(_a, ["children", "type", "size", "className", "htmlType", "shape", "shadow", "plain", "loading", "disabled", "onClick"]);
    const btnCls = useMemo(() => {
        return classnames([
            prefixCls(),
            prefixCls(`type-${type}`),
            prefixCls(`size-${size}`),
            prefixCls(`shape-${shape}`),
            {
                [prefixCls('shadow')]: shadow
            },
            {
                [prefixCls('plain')]: plain
            },
            {
                [prefixCls('disabled')]: disabled
            },
            className
        ]);
    }, [className, disabled, plain, shadow, shape, size, type]);
    const handleClick = useCallback((e) => {
        if (loading) {
            return;
        }
        onClick && onClick(e);
    }, [loading, onClick]);
    return (React.createElement("button", Object.assign({ ref: ref, className: btnCls, type: htmlType, disabled: disabled, onClick: handleClick }, restProps),
        loading && React.createElement(Loading, { className: prefixCls('loading') }),
        React.createElement("span", { className: prefixCls('text') }, children)));
});
Button.displayName = 'Button';
export default Button;
